export const SAVE_RESUME_MODE = {
  no: 'no',
  yesMinutes: 'yes_minutes',
}

export const EDIT_AFTER_SUBMISSION_MODE = {
  no: 'no',
  hours: 'hours',
  untilExpires: 'until_instance_expires',
  noLimit: 'no_limit',
}

export const SAVE_RESUME_OPTIONS = [
  { key: SAVE_RESUME_MODE.no, text: 'No, participants cannot save their progress and resume' },
  { key: SAVE_RESUME_MODE.yesMinutes, text: 'Yes, they can resume within' },
]

export const EDIT_AFTER_SUBMISSION_OPTIONS = [
  { key: EDIT_AFTER_SUBMISSION_MODE.no, text: 'No, answers are final once submitted' },
  { key: EDIT_AFTER_SUBMISSION_MODE.hours, text: 'Yes, for' },
  { key: EDIT_AFTER_SUBMISSION_MODE.untilExpires, text: 'Yes, until the instance expires' },
  { key: EDIT_AFTER_SUBMISSION_MODE.noLimit, text: 'Yes, with no time limit' },
]

export const DURATION_UNIT = {
  minutes: 'minutes',
  hours: 'hours',
  days: 'days',
  weeks: 'weeks',
}

export const DURATION_UNIT_OPTIONS = [
  { key: DURATION_UNIT.minutes, text: 'minutes' },
  { key: DURATION_UNIT.hours, text: 'hours' },
  { key: DURATION_UNIT.days, text: 'days' },
  { key: DURATION_UNIT.weeks, text: 'weeks' },
]

/** API save_and_resume uses minutes. */
export const durationToMinutes = (value, unit = DURATION_UNIT.minutes) => {
  const amount = Number(value) || 0
  if (unit === DURATION_UNIT.hours) return amount * 60
  if (unit === DURATION_UNIT.days) return amount * 24 * 60
  if (unit === DURATION_UNIT.weeks) return amount * 7 * 24 * 60
  return amount
}

/** API edit_after_submission uses hours. */
export const durationToHours = (value, unit = DURATION_UNIT.hours) => {
  const amount = Number(value) || 0
  if (unit === DURATION_UNIT.minutes) return amount / 60
  if (unit === DURATION_UNIT.days) return amount * 24
  if (unit === DURATION_UNIT.weeks) return amount * 7 * 24
  return amount
}

export const formatDurationLabel = (value, unit = DURATION_UNIT.minutes) => {
  const amount = Number(value) || 0
  const label = DURATION_UNIT_OPTIONS.find(option => option.key === unit)?.text || unit
  return `${amount} ${label}`
}
